import { BCMSRecord, DisabledPrompt, Link, useBCMSContext, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { PageContainer } from 'components/shared';
import CheckView from 'components/shared/views/CheckView';
import Classes from "model";
import React, { useEffect } from 'react';
import { ImageAsset, SVGAsset } from 'res';
import "./styles.css";

/**
 * @function CheckImagePage
 * @return {React.Component}
 * @exported true
 * @description description
 */

export default function CheckImagePage(props) {
  const { goStep, nextStep } = useWorkflow() ?? {};
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  let data = { ...getDefaultPageData(), ...props.data ?? {} };
  let ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

  // Sample code of turning off the success animation and auto route.
  /*ui.successAnimation.isSet = false;
  data.autoRouteAfterSuccessAnimation.isSet = false;*/

  const state = { data, ui };
  let timeout1;
  let timeout2;

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onCancelClick: () => goStep(0),
  });

  // Show an animated "success" message and auto route. The animation and auto route can be turned off
  // using the props in "getDefaultPageData" and "getDefaultPageUI".
  useEffect(() => {
    const setSuccessUI = () => {
      const div = document.querySelector('.success-overlay-container');
      div.style.opacity = 1;
    }
    
    if(ui.successAnimation.isSet) {
      // Show the "success" message after 1.5 seconds, and show it for 2.5 seconds.
      // Then navigate to the next page.
      timeout1 = setTimeout(() => {
        setSuccessUI();
        
        if(data.autoRouteAfterSuccessAnimation.isSet) {
          timeout2 = setTimeout(() => goStep(5,{ data: state.data, ui: state.ui } ), 2500);
        }
      }, 1500);
    } else {
      setSuccessUI();
    }

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  });

  return(
    <PageContainer className="check-image-page" state={ state } controller={ controller }> 
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultPageData = () => ({
  autoRouteAfterSuccessAnimation: { isSet: true }
});

export const getDefaultPageUI = () => ({
  successAnimation: { isSet: true }
});

function PageContent() {
  const { onCancelClick } = useStateManager();
  
  return (
    <div className="check-image-page-content flex-container flex-vertical">
      <div className="check-image-header flex-container flex-horizontal align-center space-between" onClick={ onCancelClick }>
        <Link className="back-item-container flex-container flex-horizontal align-center">
          <SVGAsset id="LeftChevronIcon" className="back-chevron left-icon inline-text-icon" />
          <span>Cancel</span>
        </Link>
        <h2 className="flex-width text-center">Check Front</h2>
        <DisabledPrompt>
          <Link>
            <SVGAsset id="HelpOutlineIcon" className="help-outline-icon" />
          </Link>
        </DisabledPrompt>
      </div> 
      <CheckView />
      <div className="check-overlay-container">
        <div className="image-container flex-container flex-horizontal all-center">
          <ImageAsset id="CheckFrontOverlay" className="check-overlay" />
        </div>
      </div>
      <div className="check-image-footer flex-container flex-horizontal align-center">
        <DisabledPrompt>
          <Link className="flex-container flex-horizontal align-center">
            <SVGAsset id="LightningIcon" className="lightning-icon left-icon inline-text-icon" />
            <p>On</p>
          </Link>
        </DisabledPrompt>
        <h2 className="text-center flex-width mitek-logo"><span className="powered-by">powered by </span><span className="Mitek">Mitek</span></h2>
      </div>
      {/* start: test success message. */}
      <div className="check-overlay-container success-overlay-container">
        <div className="overlay-item-container flex-container flex-vertical all-center">
          <div className="flex-height flex-container  all-center">
            <div className="gray-background-section flex-container flex-horizontal align-center">
              <SVGAsset id="CircleCheckmarkIcon" className="circle-check" />
              <h2>Success!</h2>
            </div>
          </div>
          <div className="powered-by-container">
            <p>powered by <span className="mitek-text">Mitek</span></p>
          </div>
        </div>
      </div>
      {/* end: test success message. */}
    </div>
  )
}